import { api } from "@/lib/api";

export const configApi = {
  // Requiere sesión autenticada como mínimo (cualquier rol) -- ver
  // CLAUDE.md 2c. La seguridad real de esta key es la restricción de
  // HTTP-referrer en Google Cloud Console, no este endpoint.
  getMapsBrowserKey: () => api.get("/api/config/maps/browser-key"),
};

export default configApi;
